import React from 'react';
const ErrorComponent = ({
  message
}: {
  message: string;
}) => {
  return <div>
      <h1>Error</h1>
      <p>{message}</p>
    </div>;
};
export default ErrorComponent;